import React from 'react';
//
import { Link } from 'react-router-dom';
//
import withTranslations from 'app/components/HOGs/withTranslations';
//
import { isIOS, isAndroid } from 'react-device-detect';
//
import { Button, Avatar, Modal } from 'antd';
//
import { START_LOGIN } from 'app/constants/enter.user.constants';
//
import { getUserLink } from 'app/components/Utility/utility';
//
import LoginStateMachine from 'app/components/Desctop/UserEnter/loginStateMachine';
//
import Switch from './Switch';
//

const RightContent = (props) => {
  const { authUserData = {}, tr } = props;
  const { name, id } = authUserData;
  const { modalOpen } = props.dataLogin;
  const tourId = +window.location.pathname.split('_').pop();

  const scope = props.router.location.pathname.includes('place')
    ? 'place'
    : 'tour';

  function go() {
    const time = new Date().getTime();
    const a = document.createElement('a');
    a.setAttribute('href', `tourstartphoneapp://${scope}/tourstart_${tourId}`);
    a.dispatchEvent(
      new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
      })
    );
    setTimeout(() => {
      setTimeout(() => {
        const now = new Date().getTime();
        if (now - time < 400) {
          document.location =
            'https://apps.apple.com/app/tourstart/id586049610';
          setTimeout(() => {
            document.location.reload();
          }, 0);
        }
      }, 10);
    }, 300);
  }

  function openApp() {
    if (isAndroid) {
      window.open(
        `intent://tourstart.org/${scope}/tourstart_${tourId}#Intent;scheme=https;package=org.tourstart;end`
      );
    } else if (isIOS) {
      go();
    }
  }

  return (
    <>
      {(isAndroid || isIOS) && tourId ? (
        <Button
          type="primary"
          onClick={() => openApp()}
          style={{ zIndex: '111111', marginRight: '15px' }}
        >
          {tr['Open in app']}
        </Button>
      ) : null}
      {<Switch {...props} />}
      {!props.isLoggedIn ? (
        <div
          className="mobileSign"
          onClick={() => props.loginModalOpen(true)}
          aria-hidden
        >
          {tr['Sign in']}
        </div>
      ) : (
        <div className="mobileUserPanel">
          <Link to={getUserLink({ name, id })}>
            <Avatar
              src={
                authUserData && authUserData.avatar ? authUserData.avatar : ''
              }
              size={35}
              alt="img"
            />
          </Link>
        </div>
      )}
      <Modal
        closable
        visible={modalOpen}
        footer={false}
        // width={275}
        width={355}
        style={{ top: 200 }}
        className="loginDesctop"
        onCancel={() => {
          props.isLoginChange(false);
          props.loginModalOpen(false);
          props.setStateUserEnter({ name: START_LOGIN });
        }}
      >
        <LoginStateMachine />
      </Modal>
    </>
  );
};

export default withTranslations(RightContent);
